import { render, staticRenderFns } from "./SupplierBlackDialog.vue?vue&type=template&id=053ccc84&"
import script from "./SupplierBlackDialog.vue?vue&type=script&lang=js&"
export * from "./SupplierBlackDialog.vue?vue&type=script&lang=js&"
import style0 from "./SupplierBlackDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports